export { default as DoubleCheckmarkIcon } from '~icons/ion/checkmark-done-sharp';
